module.exports = __webpack_public_path__ + "assets/729cf6f3c8d1d1faf7579de36d3f15ed.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/mystery/BannerIntroFlames.mp3
 ** module id = 347
 ** module chunks = 0
 **/